<template>
    <div class="card" style="min-height: 200px">
        <div class="table-responsive">
            <table class="table">
                <thead>
                <tr>
                    <th style="width: 5%">
                        <input
                            type="checkbox"
                            :checked="allSelected"
                            @change="toggleSelectAll($event.target.checked)"
                        >
                    </th>
                    <th>Stock Adj Date</th>
                    <th>Stock Adj No</th>
                    <th>Warehouse</th>
                    <th>Description</th>
                    <th>Action</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(item, i) in adjustmentList" :key="i">
                    <td>
                        <input type="checkbox" v-model="item.selected">
                    </td>
                    <td>{{ item.date }}</td>
                    <td>{{ item.adjustment_no }}</td>
                    <td>{{ warehouseName(item) }}</td>
                    <td>{{ item.description }}</td>
                    <td>
                        <button
                            class="btn btn-primary btn-sm"
                            @click="onView(item)"
                            style="cursor: pointer"
                        >
                            <i class="fas fa-eye"></i>
                        </button>
                    </td>
                </tr>
                </tbody>
            </table>
            <p v-if="!adjustmentList.length" class="text-center mt-5">No data</p>
        </div>
    </div>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
    adjustmentList: {
        type: Array,
        default: () => []
    }
})

const emit = defineEmits(['onView'])

const allSelected = computed(() => {
    if (!props.adjustmentList.length) return false
    return props.adjustmentList.every(item => item.selected === true)
})

const warehouseName = (item) => {
    if (!item.warehouse) return 'N/A'
    return item.warehouse.name
}

const toggleSelectAll = (checked) => {
    props.adjustmentList.forEach(item => {
        item.selected = checked
    })
}

const onView = (item) => {
    emit('onView', item)
}
</script>
